import { render, staticRenderFns } from "./TopicButtons.vue?vue&type=template&id=5b98e990&"
import script from "./TopicButtons.vue?vue&type=script&lang=js&"
export * from "./TopicButtons.vue?vue&type=script&lang=js&"
import style0 from "./TopicButtons.vue?vue&type=style&index=0&id=5b98e990&prod&lang=less&scoepd=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports